import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 328px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${props => props.theme.colors.white};
  padding: 10px 20px 40px 20px;

  display: flex;
  flex-direction: column;
`;

export const MenuList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0px;
  margin-bottom: 60px;

  & li {
    cursor: pointer;
    text-transform: uppercase;
    color: ${props => props.theme.colors.black};
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 0;

    &:hover {
      color: ${props => props.theme.colors.blue};
    }
  }

  > * {
    margin-bottom: 10px;
  }

  > li {
    margin-bottom: 10px;
  }

  .side-menu__link_active {
    border-radius: 10px;
    padding: 8px 15px;
    background-color: ${props => props.theme.colors.lightBlue};

    li {
      margin-bottom: 0;
    }
  }
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding: 7px;
  padding-right: 0;
  margin-bottom: 10px;
  cursor: pointer;
`;
